import {currentBoardRoute,resolveBoardRoute,type BoardRoute} from './boardRoute';

export const informationPaths=new Set(['/about/','/how-to-play/','/terms/','/privacy/']);
const returnParameter='returnTo';
const linkOrigin='https://graffiti.invalid';

/** Return context is a game path, never an arbitrary redirect or a shared last-board value. */
export function gameReturnPath(value:string|null):string {
  if(!value||!/^\/(?:[a-z0-9-]+\/?)?$/.test(value))return '/';
  const route=resolveBoardRoute(value);
  return route.kind==='game'?route.home:'/';
}

export function informationUrl(path:string,route:BoardRoute=currentBoardRoute):string {
  const url=new URL(path,linkOrigin);
  if(url.origin!==linkOrigin||!informationPaths.has(url.pathname))throw new Error('Unknown information page.');
  const home=route.kind==='game'?route.home:'/';
  if(home!=='/')url.searchParams.set(returnParameter,home);
  else url.searchParams.delete(returnParameter);
  return url.pathname+url.search+url.hash;
}

/** Update only game and information links; legal anchors, external links and page metadata stay intact. */
export function informationPageLink(href:string,pageUrl:string):string|null {
  if(href.startsWith('#'))return null;
  const page=new URL(pageUrl),url=new URL(href,page);
  if(url.origin!==page.origin)return null;
  const values=page.searchParams.getAll(returnParameter);
  const home=gameReturnPath(values.length===1?values[0]:null);
  if(url.pathname==='/'&&!url.search&&!url.hash)return home;
  if(!informationPaths.has(url.pathname))return null;
  if(home!=='/')url.searchParams.set(returnParameter,home);
  else url.searchParams.delete(returnParameter);
  return url.pathname+url.search+url.hash;
}
